/*    
<summary>
    This functional common component provides modal popup that shows add treatment confirmation message and has two buttons (i.e. yes and no) to confirm or cancel the action.   
    Developer:Aashish Singh, Created Date:05-June-2025
</summary>
<returns>Returns JSX</returns>
*/
import React from "react";
import { Modal, Button } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import LoaderButton from "../../../shared-components/button/loader-button";
import { observer } from "mobx-react";

interface Props {
  modalSubmit: () => void;
  modalClosed: () => void;
  isLoading: boolean;
  title: string;
  message?: string;
  className?: string;
  errorMsg?: string;
}

const ConfirmTreatmentAdditionPopup: React.FC<Props> = (props) => {
  return (
    <Modal show={true} centered dialogClassName="delete_popup">
      <Modal.Header>
        <Modal.Title>
          <FormattedMessage id={props.title} />
          <button
            onClick={props.modalClosed}
            disabled={props.isLoading}
            className="Crossicons"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="23"
              height="23"
              fill="currentColor"
              className="bi bi-x"
              viewBox="0 0 16 16"
            >
              <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
            </svg>
          </button>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="bootbox-body">
          <span className="text-danger">
            <FormattedMessage id={props.errorMsg} />
          </span>
          <p>
            <FormattedMessage id={props.message} />
          </p>
        </div>
      </Modal.Body>
      <Modal.Footer className="border-0 pt-0">
        <LoaderButton
          type="submit"
          iconName="bi-check-lg"
          onClick={props.modalSubmit}
          isLoading={props.isLoading}
          text="yes"
        />
        <Button
          variant="outline-danger"
          onClick={props.modalClosed}
          disabled={props.isLoading}
          className="btnOkSize"
        >
          <i className="bi bi-x-lg me-1"></i>
          <FormattedMessage id="no" />
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default observer(ConfirmTreatmentAdditionPopup);
